module.exports = __webpack_public_path__ + "img/karamoja1.0e48721b.jpg";